import styled from 'styled-components';
import { InfoButtonStyled } from '../InfoButtonStyled';
export const InfoButtonStyledDS = styled(InfoButtonStyled)`
    .InfoButton {
        &:after {
            background-image: url("data:image/svg+xml,%3Csvg data-name='0079_N73InformationXSmall_Outline' xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E%3Cdefs%3E%3CclipPath id='zv5ft082ca'%3E%3Cpath data-name='0079_N73InformationXSmall_Outline' style='fill:none' d='M0 0h16v16H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3Cg data-name='Groupe 1222' style='clip-path:url(%23zv5ft082ca)'%3E%3Cpath data-name='Tracé 705' d='M8.894 3.062h-1.8v1.39h1.8zm-.066 2.859H7.157v6.938h1.671zM8 1.843A6.156 6.156 0 1 1 1.844 8 6.156 6.156 0 0 1 8 1.843zM8 .406a7.593 7.593 0 1 0 7.594 7.593A7.593 7.593 0 0 0 8 .406z'/%3E%3C/g%3E%3C/svg%3E");
        }
    }
`;
